"use strict";
var __defProp = Object.defineProperty;
var __getOwnPropDesc = Object.getOwnPropertyDescriptor;
var __decorateClass = (decorators, target, key, kind) => {
  var result = kind > 1 ? void 0 : kind ? __getOwnPropDesc(target, key) : target;
  for (var i = decorators.length - 1, decorator; i >= 0; i--)
    if (decorator = decorators[i])
      result = (kind ? decorator(target, key, result) : decorator(result)) || result;
  if (kind && result)
    __defProp(target, key, result);
  return result;
};
var __async = (__this, __arguments, generator) => {
  return new Promise((resolve, reject) => {
    var fulfilled = (value) => {
      try {
        step(generator.next(value));
      } catch (e) {
        reject(e);
      }
    };
    var rejected = (value) => {
      try {
        step(generator.throw(value));
      } catch (e) {
        reject(e);
      }
    };
    var step = (x) => x.done ? resolve(x.value) : Promise.resolve(x.value).then(fulfilled, rejected);
    step((generator = generator.apply(__this, __arguments)).next());
  });
};
import { Component, Vue } from "vue-property-decorator";
import API from "@ym-framework/api-utils";
import UiDialog, { UiDialogController } from "@/components/dialog/UiDialog.vue";
import UiForm, { UiFormAnnotations, UiFormController } from "@/components/form/UiForm.vue";
import UiSubmit from "@/components/form/UiSubmit.vue";
import VerifyInput, { VerifyInputController } from "@/components/VerifyInput.vue";
import Cookie from "js-cookie";
import i18n from "@/lang";
export class AccountChildChangeBindDeviceForm extends UiFormController {
  constructor() {
    super(...arguments);
    this.phone = "";
    this.verifyCode = "";
  }
}
__decorateClass([
  UiFormAnnotations.Rule([{
    required: true,
    message: i18n.t("accountchildchangebinddialog.mobile_phone_number_cannot_be_empty"),
    trigger: "blur"
  }])
], AccountChildChangeBindDeviceForm.prototype, "phone", 2);
__decorateClass([
  UiFormAnnotations.Rule([{
    required: true,
    message: i18n.t("accountchildchangebinddialog.verification_code_cannot_be_empty"),
    trigger: "blur"
  }])
], AccountChildChangeBindDeviceForm.prototype, "verifyCode", 2);
let AccountChildChangeBindDialog = class extends Vue {
  constructor() {
    super(...arguments);
    this.activestep = 0;
    this.dialog = new UiDialogController();
    this.controllerOld = new AccountChildChangeBindDeviceForm();
    this.controllerNew = new AccountChildChangeBindDeviceForm();
    this.verifyOld = new VerifyInputController("api://base.auth/api/v1/verify_code/send", 11);
    this.verifyNew = new VerifyInputController("api://base.auth/api/v1/verify_code/send", 11);
  }
  mounted() {
    return __async(this, null, function* () {
    });
  }
  submitOld() {
    return __async(this, null, function* () {
      console.dir(this.controllerOld);
      this.activestep = 1;
    });
  }
  submitNew() {
    return __async(this, null, function* () {
      try {
        const response = yield API.get(`api://base.auth/api/v1/user/bindphone/verify`, {
          params: {
            phone: this.controllerNew.phone
          }
        });
        yield API.put(`api://base.auth/api/v1/user/bindphone`, {
          old_phone: this.controllerOld.phone,
          old_phone_code: this.controllerOld.verifyCode,
          code: this.controllerNew.verifyCode,
          phone: this.controllerNew.phone
        });
        this.activestep = 3;
        Cookie.set("token", "", { expires: -1 });
      } catch (error) {
        if (error.hasOwnProperty("response")) {
          this.$message.error(error.response.data.errors.datas[0].message);
        }
      }
    });
  }
  logout() {
    this.$router.push("/logout");
  }
  encryptphone(phone) {
    let _phone = phone;
    if (phone !== null) {
      let arr1 = phone.toString().substring(0, 3);
      let arr2 = phone.toString().substring(phone.toString().length - 4, phone.toString().length);
      _phone = arr1 + "****" + arr2;
    }
    return _phone;
  }
  open(phone) {
    this.activestep = 0;
    this.controllerOld.phone = phone;
    this.controllerOld.verifyCode = "";
    this.controllerNew.phone = "";
    this.controllerNew.verifyCode = "";
    this.dialog.visible = true;
  }
  close() {
    this.dialog.visible = false;
    this.$emit("refresh");
  }
};
AccountChildChangeBindDialog = __decorateClass([
  Component({
    components: {
      UiForm,
      UiSubmit,
      UiDialog,
      VerifyInput
    }
  })
], AccountChildChangeBindDialog);
export {
  AccountChildChangeBindDialog as default
};
